// Anzeigename eines Termin-Typs — eine Stelle für Kalender, Kontaktseiten und Pille.
//
// „sonstig" ist der Sammeltopf; wer ihn wählt, darf eine eigene Bezeichnung eintragen
// (`typ_freitext`, z. B. „Übergabe"). Die steht dann überall dort, wo sonst der Typ
// stünde — der Sammelbegriff selbst sagt niemandem etwas.
export const TERMIN_TYP_LABELS: Record<string, string> = {
  besichtigung: 'Besichtigung',
  wartung: 'Wartung',
  frist: 'Frist',
  meeting: 'Meeting',
  sonstig: 'Sonstiges',
  outlook: 'Outlook',
};

export function terminTypLabel(termin: { typ: string; typ_freitext?: string | null }): string {
  if (termin.typ === 'sonstig') {
    const eigen = (termin.typ_freitext || '').trim();
    if (eigen) return eigen;
  }
  return TERMIN_TYP_LABELS[termin.typ] || termin.typ;
}
